
import { Component, Vue } from "vue-property-decorator";

import * as ScraperServices from "@/services/ScraperService";
import * as FactcheckRequestServices from "@/services/FactCheckRequestServices";
import * as SeoServices from "@/services/SeoServices";
import * as RssServices from "@/services/RssServices";

@Component({
  components: {
    LogoutDialog: () => import("@/components/dialogs/LogoutDialog.vue"),
  },
})
export default class Navigation extends Vue {
  dialogs = {
    logout: false,
  };

  get admin(): boolean {
    return this.$store.state.user.profile.isAdmin;
  }

  unusedArticleCount = 0;
  unhandledRequestCount = 0;
  articlesWithNoSeo = 0;
  unseenRssItems = 0;

  async mounted() {
    const data = await ScraperServices.GetScrapedArticles(
      10,
      0,
      null,
      ["date"],
      [true]
    );
    console.log(data.rows.map(e => e.used))

    let badgeItems = data.rows.filter((e) => !e.used && !e.ignored);

    this.unusedArticleCount = badgeItems.length;

    const requests = await FactcheckRequestServices.GetRequests();
    this.unhandledRequestCount = requests.filter((e) => !e.answered).length;

    const articlesWithoutSeo =
      await SeoServices.GetFactchecksWithoutSeoConfig();
    this.articlesWithNoSeo = articlesWithoutSeo.length;
  }
}
